import * as _4 from 'lodash';

interface ICondition<E> {
  (e: E): boolean;
}

/**
 * ConditionalStrategy
 *
 * @description represents logic around a set of data (context) which reduces to a single algorithm selection
 */
export class ConditionalStrategy<E, T extends string> {
  constructor(private __rules: Record<T, ICondition<E>>) {}

  evaluate(executionContext: E, defaultValue?: T): T {
    return (
      (_4.findKey(this.__rules, function (condition: ICondition<E>) {
        return condition(executionContext);
      }) as T) || (defaultValue as T)
    );
  }
}

export class ConditionalStrategySafe<E, T extends string> extends ConditionalStrategy<E, T> {}



// WEBPACK FOOTER //
// ./app/vendor/utility-ts-strategy/src/lib/conditional_strategy.ts